import { IChipItem } from "../../../../ui/FormChipInput/ChipItem";

export const UPDATE_EMAIL_LIST = "UPDATE_EMAIL_LIST";

export function updateEmailList(emailList: IChipItem[]) {
    return {
      type: UPDATE_EMAIL_LIST,
      payload: emailList,
    };
  }
export const HAS_SELECTED_PERMISSION = "UPDATE_SELECTED_PERMISSION";

export function hasSelectedPermission(isSelected: boolean) {
    return {
      type: HAS_SELECTED_PERMISSION,
      payload: isSelected,
    };
  }